import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import DashboardService from "../../../../services/OrderingServices/DashboardService";
import CountUp from "react-countup";

const timeRanges = [
  { label: "Last 1 Day", value: 1 },
  { label: "Last 7 Days", value: 2 },
  { label: "Last 30 Days", value: 3 },
  { label: "1 year", value: 4 },
  { label: "All Time", value: 5 },
];

const itemsPerPage = 5;

const BestSellingProducts = () => {
  const [data, setData] = useState([]);
  const [timeRange, setTimeRange] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const topN = 50;

  const fetchData = async () => {
    try {
      const response = await DashboardService.getTopItem(timeRange, topN);

      setData(response || []);
      setCurrentPage(1); // reset to first page on filter change
    } catch (error) {
      console.error("Failed to fetch data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [timeRange]);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = data.slice(startIndex, startIndex + itemsPerPage);
  const totalPages = Math.ceil(data.length / itemsPerPage);

  return (
    <Card className="h-100">
      <CardHeader className=" border-0 align-items-center d-flex">
        <h4 className="card-title mb-0 flex-grow-1">Best Selling Products</h4>
        <div className="flex-shrink-0">
          <UncontrolledDropdown
            className="card-header-dropdown"
            direction="start"
          >
            <DropdownToggle tag="a" className="text-reset" role="button">
              <span className="fw-bold text-uppercase fs-12">Sort by: </span>
              <span className="text-muted">
                {timeRanges.find((r) => r.value === timeRange)?.label}
                <i className="mdi mdi-chevron-down ms-1"></i>
              </span>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
              {timeRanges.map((range) => (
                <DropdownItem
                  key={range.value}
                  onClick={() => setTimeRange(range.value)}
                >
                  {range.label}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
      </CardHeader>

      <CardBody>
        <div
          className="table-responsive"
          style={{ minHeight: "300px", overflowY: "auto" }}
        >
          <table className="table table-hover table-centered align-middle table-nowrap mb-0">
            <thead>
              <tr>
                <th>Product</th>
                <th>Quantity Sold</th>
                <th>Percentage (%)</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.map((item, key) => (
                <tr key={key} className="align-middle py-4">
                  <td>
                    <h5 className="fs-14 my-1">
                      <Link to="#" className="text-reset">
                        {item.productName}
                      </Link>
                    </h5>
                  </td>
                  <td className="d-flex align-items-center py-4">
                    <CountUp
                      start={0}
                      prefix={item.prefix}
                      suffix={item.suffix}
                      separator={item.separator}
                      end={item.quantity}
                      decimals={item.decimals}
                      duration={2.5}
                    />
                    <span className="text-muted ms-2">Orders</span>
                  </td>
                  <td className="py-3">
                    <div className="d-flex align-items-center">
                      <CountUp
                        start={0}
                        prefix={item.prefix}
                        suffix={item.suffix}
                        separator={item.separator}
                        end={item.percentage}
                        decimals={item.decimals}
                        duration={2.5}
                      />
                      <span className="text-muted ms-2">Of Total</span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination inside same container */}
        {data.length > itemsPerPage && (
          <div className="d-flex align-items-center justify-content-between mt-3">
            <div className="text-muted">
              Showing{" "}
              <span className="fw-semibold">
                {startIndex + 1}-
                {Math.min(startIndex + itemsPerPage, data.length)}
              </span>{" "}
              of <span className="fw-semibold">{data.length}</span> Results
            </div>
            <ul className="pagination pagination-separated pagination-sm mb-0">
              <li className={`page-item ${currentPage === 1 && "disabled"}`}>
                <Link
                  to="#"
                  className="page-link"
                  onClick={() =>
                    currentPage > 1 && setCurrentPage(currentPage - 1)
                  }
                >
                  ←
                </Link>
              </li>
              {Array.from({ length: totalPages }, (_, idx) => (
                <li
                  key={idx}
                  className={`page-item ${currentPage === idx + 1 && "active"}`}
                >
                  <Link
                    to="#"
                    className="page-link"
                    onClick={() => setCurrentPage(idx + 1)}
                  >
                    {idx + 1}
                  </Link>
                </li>
              ))}
              <li
                className={`page-item ${
                  currentPage === totalPages && "disabled"
                }`}
              >
                <Link
                  to="#"
                  className="page-link"
                  onClick={() =>
                    currentPage < totalPages && setCurrentPage(currentPage + 1)
                  }
                >
                  →
                </Link>
              </li>
            </ul>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default BestSellingProducts;
